import {Component} from '@angular/core';
import {Field} from '../../model/field.model';
import {ActivatedRoute, Router} from '@angular/router';
import {StateService} from '../../state.service';

@Component({
    selector: 'app-edit-field',
    templateUrl: './edit-field.component.html',
    styleUrls: ['./edit-field.component.css'],
    standalone: false
})
export class EditFieldComponent {
  field: Field;
  submitted = false;

  constructor(private route: ActivatedRoute, private router: Router, private stateService: StateService) {
    if (!this.stateService.field) {
      this.router.navigate( ['field']);
    }
    this.field = this.stateService.field;
  }

  onSubmit() {
    this.stateService.updateField(this.field);
    this.submitted = true;
    this.router.navigate( ['field']);
  }

}
